export const LIVE_CHANNEL_STATUS_TONES = {
  LIVE: {
    background: "transparent",
    border: "#fb7185",
    text: "#fb7185",
  },
  RESERVED: {
    background: "rgba(99, 102, 241, 0.16)",
    border: "rgba(165, 180, 252, 0.72)",
    text: "#a5b4fc",
  },
  READY: {
    background: "rgba(34, 197, 94, 0.14)",
    border: "rgba(74, 222, 128, 0.72)",
    text: "#4ade80",
  },
  SUSPENDED: {
    background: "rgba(245, 158, 11, 0.12)",
    border: "rgba(251, 191, 36, 0.72)",
    text: "#fbbf24",
  },
  ENDED: {
    background: "rgba(255, 255, 255, 0.06)",
    border: "rgba(255, 255, 255, 0.12)",
    text: "rgba(255, 255, 255, 0.46)",
  },
  DEFAULT: {
    background: "rgba(255, 255, 255, 0.06)",
    border: "rgba(255, 255, 255, 0.12)",
    text: "rgba(255, 255, 255, 0.46)",
  },
};

export const LIVE_CHANNEL_ITEM_TOKENS = {
  border: "rgba(255, 255, 255, 0.08)",
  borderSoft: "rgba(255, 255, 255, 0.08)",
  background: "transparent",
  backgroundSelected: "transparent",
  borderSelected: "rgba(255, 255, 255, 0.08)",
  title: "#ffffff",
  channelId: "rgba(255, 255, 255, 0.30)",
  mutedText: "rgba(255, 255, 255, 0.40)",
  action: "rgba(255, 255, 255, 0.40)",
  actionHover: "rgba(255, 255, 255, 0.72)",
  disabledOverlay: "rgba(255, 255, 255, 0.24)",
  shadowSelected: "none",
};

export const LIVE_CHANNEL_TOGGLE_TOKENS = {
  trackOff: "#8b8b8f",
  trackOn: "#5959ef",
  thumb: "#ffffff",
  trackDisabled: "#6b6b72",
  thumbShadow: "0 2px 6px rgba(15, 23, 42, 0.18)",
  focus: "0 0 0 3px rgba(89, 89, 239, 0.16)",
};
